import { useContext } from 'react';
import { HeroSliderAdminContext, HeroSliderPublicContext } from './HeroSliderContext';

export const useHeroSliderAdmin = () => {
    const ctx = useContext(HeroSliderAdminContext);
    if (!ctx) throw new Error('useHeroSliderAdmin must be used within HeroSliderAdminProvider');
    return ctx;
};

export const useHeroSliderPublic = () => {
    const ctx = useContext(HeroSliderPublicContext);
    if (!ctx) throw new Error('useHeroSliderPublic must be used within HeroSliderPublicProvider');
    return ctx;
};
